import { API_BASE_URL } from "./apiConfig";

export const searchBrandByLabel = async (/*token: string,*/ query: string, language: string) => {
	try {
		const endpoint = `${API_BASE_URL}cf/brand_label_autocomplete`;
		console.debug("🌐 Fetching from:", endpoint);

		const response = await fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				//Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ query, lang: language, drop_empty: true }),
		});

		if (!response.ok) {
			console.error(`❌ API error: ${response.status}`, await response.text());
			throw new Error('API_ERROR');
		}

		const brands = await response.json();
		console.debug("📦 Raw brand response:", brands);

		return brands.map((item: any) => ({
			code: item.brand_code,
			name: item.brand_label,
			domain: item.domain || null,
			isNew: item.new,
			faviconUrl: item.favicon_url || '',
		}));
	} catch (error) {
		console.error('❌ Error fetching brand data:', error);
		throw new Error('USER_DATA_FETCH_FAILED');
	}
};